import React, { useEffect } from "react";
import CreateQuestionForm from "./CreateQuestions";
import SearchQuestions from "./SearchQuestionCommunity";
import HelpSection from "./HelpSectionCommunity";
import ListQuestionAndSearch from "./ListQuestion";
import { connect } from 'react-redux';
import { useMediaQuery } from '@material-ui/core'
import { pagingQuestion, moreQuestion, setCommunityKey } from "../../store/actions/CommunityAction";
import { showLoading, hideLoading } from "../../store/actions/LoadingActions";
// import CardComunityMain from './CardsComunity/CardComunityMain'
// import CardAnswerQuestion from './CardsComunity/CardAnswerQuestion/CardAnswerQuestion'
import "./Comunity.scss";

function ComunityContent(props) {
    const {
        pagingQuestion,
        listQuestion,
        moreQuestion,
        setCommunityKey,
        // moreAnsweredQuestion
        role,
        keyValue,
    } = props

    const isMobile = useMediaQuery('(max-width: 1242.98px)')
    const isPhone = useMediaQuery('(max-width: 499.98px)')

    useEffect(() => {
        if (!window.inAnswers) {
            showLoading()
            handleGetListQuestion();
            hideLoading()
        }
        delete window.inAnswers
    }, []);

    const handleGetListQuestion = async () => {
        pagingQuestion(undefined, 1)
        setCommunityKey('')
        moreQuestion()
    }

    console.log('listQuestion', listQuestion);

    return (
        <div className="comunity">
            {!role || role === 'cliente' ?
                <div className="communityFirstContainer">
                    <p 
                        className={
                            role && role === 'cliente' ?
                            "communityTitleClient" :
                            "communityTitleNoRole"
                        }
                    >
                        Comunidad{isPhone ? <br/> : ''} Contacta Abogado®
                    </p>
                    {keyValue ? 
                        <p className="communityFilterResultClient">Preguntas acerca de{isPhone ? <br/> : ''} "<span className="communityFilterSpan">{keyValue}</span>"</p> :
                        null
                    }
                    <div className="contentFormsCommunity">
                        <div className="contentQuestionForm">
                            <CreateQuestionForm /> 
                        </div>
                        <div className="contentSearch">
                            <SearchQuestions />
                            <HelpSection />
                        </div>
                    </div>
                    <div className={
                        listQuestion &&
                        listQuestion.data &&
                        listQuestion.data.length !== 0 ?
                        "contentFormsCommunity" :
                        "contentFormsCommunityEnd"
                    }>
                        <div
                            className={
                                role && role === 'cliente' ?
                                "contentListQuestionClient" :
                                "contentListQuestionNoRole"
                            }
                        >
                            <ListQuestionAndSearch type="list" />
                        </div>
                        <div
                            className={
                                role && role === 'cliente' ?
                                "contentMostResponseClient" :
                                "contentMostResponseNoRole"
                            }
                        >
                            <ListQuestionAndSearch />
                        </div>
                    </div>
                </div> :
                <div className="communityFirstContainerLawyer">
                    <p className="communityTitle">Comunidad{isPhone ? <br/> : ''} Contacta Abogado®</p>
                    {keyValue && !isMobile ? 
                        <p className="communityFilterResult">Preguntas acerca de "<span className="communityFilterSpan">{keyValue}</span>"</p> :
                        null
                    }
                    <div className="contentFormsCommunity">
                        {!isMobile ?
                            <>
                                <div className="contentListQuestion">
                                    <ListQuestionAndSearch type="list" isLawyer />
                                </div>
                                <div className="contentSearchLawyer">
                                    <SearchQuestions isLawyer />
                                    <HelpSection isLawyer />
                                    <ListQuestionAndSearch isLawyer />
                                </div>
                            </> :
                            <>
                                <div className="contentListQuestion">
                                    <SearchQuestions isLawyer />
                                    {keyValue ? 
                                        <p className="communityFilterResult">Preguntas acerca de{isPhone ? <br/> : ''} "<span className="communityFilterSpan">{keyValue}</span>"</p> :
                                        null
                                    }
                                    <ListQuestionAndSearch type="list" isLawyer />
                                </div>
                                <div className="contentSearchLawyer">
                                    <ListQuestionAndSearch isLawyer />
                                    <HelpSection isLawyer />
                                </div>
                            </>
                        }
                    </div>
                </div>
            }
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    pagingQuestion: (search, page) => dispatch(pagingQuestion(search, page)),
    setCommunityKey: key => dispatch(setCommunityKey(key)),
    moreQuestion: () => dispatch(moreQuestion()),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
})

const mapStateToProps = state => ({
    laywerUid: state.authClient.uid,
    role: state.authClient.role,
    listQuestion: state.communityReducer.listQuestions,
    moreAnsweredQuestion: state.communityReducer.moreAnsweredQuestion,
    keyValue: state.communityReducer.keyValue
});

export default connect(mapStateToProps, mapDispatchToProps)(ComunityContent);
